/**
 * Hook to listen for craft completion events via WebSocket
 * Automatically triggers the craft complete toast notification when a job completes
 */

import { useSimpleWebSocketEvent } from './useWebSocketEvent'
import { useToast } from '../contexts/ToastContext'

export function useCraftComplete(isAuthenticated = false) {
  const toast = useToast()

  useSimpleWebSocketEvent(
    'crafting.job.completed',
    (event) => {
      console.log('🔨 Craft completion event received:', event)

      if (!event.result_item_name) {
        console.warn('Craft completion event missing result_item_name:', event)
        return
      }

      // Show craft complete toast notification
      toast.craftComplete(event.result_item_name)
    },
    isAuthenticated,
    [toast]
  )
}

export default useCraftComplete
